import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LayoutDashboard, Users, Briefcase, ListPlus, AlertCircle, Bell, Settings as SettingsIcon, LogOut, TrendingUp } from 'lucide-react';

export default function Layout({ children, active }) {
  const handleLogout = () => {
    localStorage.removeItem('slotrescue_token');
    localStorage.removeItem('slotrescue_user');
    window.location.href = '/login';
  };

  const navItems = [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/', key: 'dashboard' },
    { label: 'Predictions', icon: TrendingUp, path: '/predictions', key: 'predictions' },
    { label: 'Staff', icon: Users, path: '/staff', key: 'staff' },
    { label: 'Services', icon: Briefcase, path: '/services', key: 'services' },
    { label: 'Waitlist', icon: ListPlus, path: '/waitlist', key: 'waitlist' },
    { label: 'Cancellations', icon: AlertCircle, path: '/cancellations', key: 'cancellations' },
    { label: 'Notifications', icon: Bell, path: '/notifications', key: 'notifications' },
    { label: 'Settings', icon: SettingsIcon, path: '/settings', key: 'settings' },
  ];

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <div className="bg-white/80 backdrop-blur-xl border-b border-white/20 shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-2xl font-bold text-teal-900" style={{ fontFamily: 'Manrope' }}>
              SlotRescue
            </Link>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              data-testid="logout-button"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex gap-8">
          <aside className="w-64 flex-shrink-0">
            <nav className="space-y-1">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = active === item.key;
                return (
                  <Link
                    key={item.key}
                    to={item.path}
                    data-testid={`nav-${item.key}`}
                    className={`flex items-center gap-3 px-4 py-3 rounded-md transition-all ${
                      isActive
                        ? 'bg-teal-50 text-teal-900 font-medium'
                        : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                    }`}
                  >
                    <Icon className="h-5 w-5" />
                    {item.label}
                  </Link>
                );
              })}
            </nav>
          </aside>

          <main className="flex-1">{children}</main>
        </div>
      </div>
    </div>
  );
}
